import {
    ColoursObj,
    Gutters,
    MenuButton,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { openBrowser } from '../../../utils'
import { useDeviceInfo } from '../../appState/deviceInfo'
import { NavigationView } from '../../layout/NavigationView'

export const AboutPage = () => {
    const { version } = useDeviceInfo(
        useShallow((s) => {
            return { version: s.version }
        })
    )
    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.about')}
            backButtonAction={() => {
                window.pushPath('/account/settings')
            }}
            usePageTransition
        >
            <Gutters style={{ height: '100%' }} topPadding="16px">
                <Stack direction="column" alignItems="center" gap="8px">
                    <MenuButton
                        onClick={() => {
                            window.pushPath('/account/licenses')
                        }}
                        endIcon={'Chevron_Right'}
                        endIconColour={ColoursObj.font.primary}
                        style={{ background: ColoursObj.backgrounds.secondary }}
                    >
                        <Typography
                            variant="bodyRegular"
                            color={ColoursObj.font.primary}
                        >
                            {i18n.t('account.licences')}
                        </Typography>
                    </MenuButton>
                    <MenuButton
                        onClick={() => {
                            openBrowser(
                                'https://eventr.softpauer.com/?page_id=3'
                            )
                        }}
                        endIcon={'Leave_App'}
                        endIconColour={ColoursObj.font.primary}
                        style={{ background: ColoursObj.backgrounds.secondary }}
                    >
                        <Typography
                            variant="bodyRegular"
                            color={ColoursObj.font.primary}
                        >
                            {i18n.t('account.policy')}
                        </Typography>
                    </MenuButton>
                    <MenuButton
                        onClick={() => {
                            window.pushPath('/account/credits')
                        }}
                        endIconColour={ColoursObj.font.primary}
                        endIcon={'Chevron_Right'}
                        style={{ background: ColoursObj.backgrounds.secondary }}
                    >
                        <Typography
                            variant="bodyRegular"
                            color={ColoursObj.font.primary}
                        >
                            {i18n.t('account.credits')}
                        </Typography>
                    </MenuButton>
                    {version && version.buildVersion !== '' && (
                        <MenuButton
                            onClick={() => {}}
                            style={{
                                background: ColoursObj.backgrounds.secondary,
                            }}
                        >
                            <Typography
                                variant="bodyRegular"
                                color={ColoursObj.font.primary}
                            >
                                {i18n.t('account.version')}:{' '}
                                {version.buildVersion}
                            </Typography>
                        </MenuButton>
                    )}
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
